import React, { PropTypes, Component } from 'react';
import { media } from 'style-utils';
import styled from 'styled-components';
import Page from '../../components/layouts/Page';

const Container = styled.div`

  padding: 0 16px;
  max-width: 100%;
  margin: 0 auto;

  ${media.ipadProLandscape`
    width: 100% !important;
  `}

  ${media.desktop`
    width: 1342px;
  `}

  ${media.mobile`
    width: 1200px;
    padding-top: 16px;
    padding-right: 16px;
    padding-bottom: 0px;
    padding-left: 16px;;
  `}

  ${media.tablet`
    width: 1200px;
    padding-top: 16px;
    padding-right: 16px;
    padding-bottom: 0px;
    padding-left: 16px;
  `}


  width: ${props => props.wide && '80%'};
`;

class ReportingLayout extends Component {
  render() {
    return (
      <Container>
        <Page header>{this.props.children}</Page>
      </Container>
    );
  }
}

ReportingLayout.propTypes = {
  children: PropTypes.object,
};

export default ReportingLayout;



// WEBPACK FOOTER //
// ./src/layouts/fleet/ReportingLayout.js